import { CanAccess } from '@modules/common/components/CanAccess';
import { Direction } from '@modules/common/types';
import { DashboardAddContentMenu } from '@modules/dashboard/components/DashboardAddContentMenu';
import { useIsDashboardEditable } from '@modules/dashboard/hooks';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { AddRounded } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { useState } from 'react';

interface DashboardHeaderAddAnalysisButtonProps {
  setIsHovered?: (value: boolean) => void;
  buttonProps?: ButtonProps;
}

export const DashboardHeaderAddAnalysisButton = ({
  setIsHovered,
  buttonProps,
}: DashboardHeaderAddAnalysisButtonProps) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(menuAnchor);
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);

  const isEditable = useIsDashboardEditable();

  if (!dashboard || (!isEditable && dashboard.id)) {
    return null;
  }

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
    setIsHovered && setIsHovered(false);
  };

  return (
    <>
      <CanAccess
        operation={PermissionOperation.Write}
        resource={PermissionResource.Artefact}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={openMenu}
          startIcon={<AddRounded />}
          onMouseEnter={() => setIsHovered && setIsHovered(true)}
          onMouseLeave={() =>
            isMenuOpen || (setIsHovered && setIsHovered(false))
          }
          {...buttonProps}
        >
          Add
        </Button>
      </CanAccess>
      <DashboardAddContentMenu
        isOpen={isMenuOpen}
        anchorEl={menuAnchor}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        shouldShowNewOptions={true}
        cellInsertDirection={Direction.Bottom}
      />
    </>
  );
};
